import { useMemo } from 'react';
import AreaHttp from './http/area.http';
import AttributesHttp from './http/attributes.http';
import AuthHttp from './http/auth.http';
import AutomationTemplatesHttp from './http/automation-templates.http';
import AutomationsHttp from './http/automations.http';
import CardBlacklistHttp from './http/card-blacklist.http';
import ChargingStationsHttp from './http/charging-stations.http';
import ChargingPointHttp from './http/chargingPoint.http';
import CustomRuleHttp from './http/customRule.http';
import DriverShiftHttp from './http/driver-shift.http';
import DriverHttp from './http/driver.http';
import ExtraServicesHttp from './http/extraServices.http';
import FareGroupHttp from './http/fareGroup.http';
import FaresHttp from './http/fares.http';
import GeoLocationHttp from './http/geoLocation.http';
import GoogleHttp from './http/google.http';
import HolidayHttp from './http/holidays.http';
import IntegrationsHttp from './http/integrations.http';
import JobsHttp from './http/jobs.http';
import LocationHttp from './http/location.http';
import ParentHttp from './http/parent.http';
import PassengerHttp from './http/passenger.http';
import PaymentHttp from './http/payment.http';
import ProductionHttp from './http/production.http';
import ProfileHttp from './http/profile.http';
import RateHttp from './http/rate.http';
import RateGroupHttp from './http/rateGroup.http';
import ReportsHttp from './http/reports.http';
import RolesHttp from './http/roles.http';
import ServiceHttp from './http/service.http';
import SettingHttp from './http/setting.http';
import ShiftHttp from './http/shift.http';
import ShuttleHttp from './http/shuttle.http';
import SiteHttp from './http/site.http';
import SupplierHttp from './http/supplier.http';
import SettingsTemplatesHttp from './http/templatesSettings.http';
import ThemesHttp from './http/themes.http';
import TimelineHttp from './http/timeline.http';
import TripHttp from './http/trip.http';
import UserHttp from './http/user.http';
import VehicleHttp from './http/vehicle.http';

const area = new AreaHttp();
const vehicle = new VehicleHttp();
const supplier = new SupplierHttp();
const service = new ServiceHttp();
const driverShift = new DriverShiftHttp();
const profile = new ProfileHttp();
const extraService = new ExtraServicesHttp();
const job = new JobsHttp();
const location = new LocationHttp();
const google = new GoogleHttp();
const driver = new DriverHttp();
const site = new SiteHttp();
const passenger = new PassengerHttp();
const setting = new SettingHttp();
const auth = new AuthHttp();
const fares = new FaresHttp();
const fareGroup = new FareGroupHttp();
const rateGroup = new RateGroupHttp();
const shuttle = new ShuttleHttp();
const payment = new PaymentHttp();
const trip = new TripHttp();
const shift = new ShiftHttp();
const user = new UserHttp();
const rate = new RateHttp();
const attributes = new AttributesHttp();
const roles = new RolesHttp();
const production = new ProductionHttp();
const reports = new ReportsHttp();
const holiday = new HolidayHttp();
const cardBlacklist = new CardBlacklistHttp();
const automations = new AutomationsHttp();
const automationTemplates = new AutomationTemplatesHttp();
const integrations = new IntegrationsHttp();
const parent = new ParentHttp();
const settingsTemplates = new SettingsTemplatesHttp();
const chargingPoint = new ChargingPointHttp();
const geoLocation = new GeoLocationHttp();
const customRule = new CustomRuleHttp();
const theme = new ThemesHttp();
const chargingStations = new ChargingStationsHttp();
const timeline = new TimelineHttp();

type HttpHook = {
  area: AreaHttp;
  chargingPoint: ChargingPointHttp;
  vehicle: VehicleHttp;
  supplier: SupplierHttp;
  service: ServiceHttp;
  driverShift: DriverShiftHttp;
  profile: ProfileHttp;
  extraService: ExtraServicesHttp;
  job: JobsHttp;
  location: LocationHttp;
  google: GoogleHttp;
  driver: DriverHttp;
  site: SiteHttp;
  passenger: PassengerHttp;
  auth: AuthHttp;
  fares: FaresHttp;
  fareGroup: FareGroupHttp;
  rateGroup: RateGroupHttp;
  shuttle: ShuttleHttp;
  payment: PaymentHttp;
  trip: TripHttp;
  shift: ShiftHttp;
  user: UserHttp;
  rate: RateHttp;
  setting: SettingHttp;
  attributes: AttributesHttp;
  roles: RolesHttp;
  production: ProductionHttp;
  reports: ReportsHttp;
  holiday: HolidayHttp;
  cardBlacklist: CardBlacklistHttp;
  automations: AutomationsHttp;
  integrations: IntegrationsHttp;
  parent: ParentHttp;
  settingsTemplates: SettingsTemplatesHttp;
  geoLocation: GeoLocationHttp;
  customRule: CustomRuleHttp;
  automationTemplates: AutomationTemplatesHttp;
  theme: ThemesHttp;
  chargingStations: ChargingStationsHttp;
  timeline: TimelineHttp;
};

const useHttp = (): HttpHook => {
  return useMemo(() => {
    return {
      integrations,
      area,
      vehicle,
      supplier,
      service,
      driverShift,
      profile,
      extraService,
      job,
      location,
      google,
      driver,
      site,
      passenger,
      setting,
      auth,
      fares,
      shuttle,
      payment,
      trip,
      shift,
      user,
      rate,
      attributes,
      roles,
      production,
      reports,
      fareGroup,
      rateGroup,
      holiday,
      cardBlacklist,
      automations,
      parent,
      settingsTemplates,
      chargingPoint,
      geoLocation,
      customRule,
      automationTemplates,
      theme,
      chargingStations,
      timeline,
    };
  }, []);
};

export default useHttp;
